import { render, staticRenderFns } from "./refundInfo.vue?vue&type=template&id=5ef22cfe&scoped=true&"
import script from "./refundInfo.vue?vue&type=script&lang=js&"
export * from "./refundInfo.vue?vue&type=script&lang=js&"
import style0 from "./refundInfo.vue?vue&type=style&index=0&id=5ef22cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef22cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ef22cfe')) {
      api.createRecord('5ef22cfe', component.options)
    } else {
      api.reload('5ef22cfe', component.options)
    }
    module.hot.accept("./refundInfo.vue?vue&type=template&id=5ef22cfe&scoped=true&", function () {
      api.rerender('5ef22cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale-nc/detail/components/refundInfo.vue"
export default component.exports